import Vue from 'vue'
import Router from 'vue-router'
import Landing from '@/components/Landing'
import NotFound from '@/components/NotFound'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/sites/utb-v1/',
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: Landing
    },
    {
      path: '*',
      component: NotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js